export const getIsProductionHost = () => 'app.manychat.com' === window?.location?.host
